import { Box, CircularProgress, SxProps } from "@mui/material";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import theme from "styles/theme";



interface Props {
    url: string
    onClick?: () => void
    sx?: SxProps
}

const ImageCmp: FunctionComponent<Props> = ({
    url,
    onClick,
    sx,
}) => {

    // STORE

    // STATES
    const [isVisible, setIsVisible] = useState(false);
    let [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const imageRef = useRef<HTMLDivElement>(null);

    // HOOKs
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
                // if (entry.isIntersecting && !isVisible) {
                //     setIsVisible(true);
                // }
            },
            { threshold: 0.1 }
        )
        if (imageRef.current) {
            observer.observe(imageRef.current);
        }
        return () => {
            if (imageRef.current) {
                observer.unobserve(imageRef.current);
            }
        }
    }, [])

    // HANDLERS
    const handleImageLoad = () => {
        setIsLoading(false);
        setHasError(false);
    }

    const handleImageError = () => {
        setIsLoading(false);
        setHasError(true);
    }

    // RENDER
    //const isCliccable = !!onClick && isVisible && !isLoading && !hasError

    //isLoading = true

    return (
        // <Box ref={imageRef} sx={[sxRoot, { cursor: isCliccable ? "pointer" : null }, sx] as SxProps}
        //     onClick={isCliccable ? onClick : undefined}
        // >
        <Box ref={imageRef} sx={[sxRoot, { cursor: "pointer" }, sx] as SxProps}
            onClick={onClick}
        >

            {
                !isVisible ? (
                    <Box />
                ) : isLoading ? (
                    <CircularProgress size={25} />
                ) : hasError && (
                    <Box sx={sxError}>ERROR LOADING IMAGE</Box>
                )
            }

            {isVisible && !hasError && (
                <img
                    src={url}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                    style={styImg(isLoading)}
                />
            )}

        </Box>
    )
}

export default ImageCmp

const sxRoot: SxProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",
    borderRadius: "5px",
    overflow: "hidden",
    bgcolor: "rgba(0, 0, 0, 0.2)",
}

const sxError: SxProps = {
    color: theme.palette.error.main,
    textAlign: "center",
    fontSize: 12,
    fontWeight: 500,
    p: 1
}

const styImg = (loading: boolean): React.CSSProperties => ({
    display: loading ? "none" : "block",
    objectFit: "cover",
    width: "100%",
    height: "100%",
})
